import { cn } from '@/lib/utils';

const statusConfig = {
  // Task statuses em português
  planejado: { label: 'PLANEJADO', className: 'bg-zinc-500/10 text-zinc-400 border-zinc-500/20' },
  aprovado: { label: 'APROVADO', className: 'bg-blue-500/10 text-blue-400 border-blue-500/20' },
  concluido: { label: 'CONCLUÍDO', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  
  // Old task statuses (backwards compatibility)
  backlog: { label: 'PLANEJADO', className: 'bg-zinc-500/10 text-zinc-400 border-zinc-500/20' },
  todo: { label: 'PLANEJADO', className: 'bg-blue-500/10 text-blue-400 border-blue-500/20' },
  doing: { label: 'APROVADO', className: 'bg-amber-500/10 text-amber-400 border-amber-500/20' },
  blocked: { label: 'APROVADO', className: 'bg-red-500/10 text-red-400 border-red-500/20' },
  done: { label: 'CONCLUÍDO', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  canceled: { label: 'CANCELADO', className: 'bg-zinc-600/10 text-zinc-500 border-zinc-600/20' },
  
  // Run statuses
  pending: { label: 'PENDENTE', className: 'bg-zinc-500/10 text-zinc-400 border-zinc-500/20' },
  running: { label: 'EXECUTANDO', className: 'bg-blue-500/10 text-blue-400 border-blue-500/20 animate-pulse' },
  success: { label: 'SUCESSO', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  failed: { label: 'FALHOU', className: 'bg-red-500/10 text-red-400 border-red-500/20' },
  
  // Work item statuses
  processing: { label: 'PROCESSANDO', className: 'bg-blue-500/10 text-blue-400 border-blue-500/20 animate-pulse' },
  
  // Project statuses
  active: { label: 'ATIVO', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  ativo: { label: 'ATIVO', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  producao: { label: 'PRODUÇÃO', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  em_andamento: { label: 'EM ANDAMENTO', className: 'bg-blue-500/10 text-blue-400 border-blue-500/20' },
  planejamento: { label: 'PLANEJAMENTO', className: 'bg-purple-500/10 text-purple-400 border-purple-500/20' },
  paused: { label: 'PAUSADO', className: 'bg-amber-500/10 text-amber-400 border-amber-500/20' },
  pausado: { label: 'PAUSADO', className: 'bg-amber-500/10 text-amber-400 border-amber-500/20' },
  archived: { label: 'ARQUIVADO', className: 'bg-zinc-600/10 text-zinc-500 border-zinc-600/20' },
  arquivado: { label: 'ARQUIVADO', className: 'bg-zinc-600/10 text-zinc-500 border-zinc-600/20' },
  cancelado: { label: 'CANCELADO', className: 'bg-red-500/10 text-red-400 border-red-500/20' },
  
  // Security levels
  critical: { label: 'CRÍTICO', className: 'bg-red-500/10 text-red-400 border-red-500/20' },
  warning: { label: 'ALERTA', className: 'bg-amber-500/10 text-amber-400 border-amber-500/20' },
  info: { label: 'INFO', className: 'bg-blue-500/10 text-blue-400 border-blue-500/20' },
  
  // Risk levels
  low: { label: 'BAIXO', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  medium: { label: 'MÉDIO', className: 'bg-amber-500/10 text-amber-400 border-amber-500/20' },
  high: { label: 'ALTO', className: 'bg-red-500/10 text-red-400 border-red-500/20' },
};

export function StatusBadge({ status, className }) {
  const config = statusConfig[status] || { label: status?.toUpperCase() || 'DESCONHECIDO', className: 'bg-zinc-500/10 text-zinc-400 border-zinc-500/20' };
  
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm px-1.5 py-0.5 text-[10px] font-bold tracking-widest border',
        config.className,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </span>
  );
}
